<template>
  <v-layout align-start>
    <v-container>
      <h1>BITACORA PROVIDER</h1>
      <v-btn @click="dialog = true">Abrir bitacora</v-btn>
      <v-dialog v-model="dialog" max-width="700px" persistent>
        <v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" v-for="(item, i) in dataSplit" :key="i">
                  <v-textarea
                    v-model="item.seguimiento"
                    label="SEGUIMIENTO"
                    counter
                    auto-grow
                    hint="PRESIONE ENTER PARA ASIGNAR FECHA Y SU NOMBRE"
                    persistent-hint
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="agregarComponente()">Agregar</v-btn>
            <v-btn @click="dialog = false">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="actualizar()">Actualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      data: [],
      splitData: [],
      dataSplit: [],
      seguimiento: "",
      dialog: false,
      contador: 1,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let me = this;
      var dateFormat = new Date();
      let dateToday =
        dateFormat.getFullYear() +
        "-" +
        (dateFormat.getMonth() + 1) +
        "-" +
        dateFormat.getDate();
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Bitacoras/Listar/" + dateToday + "/" + dateToday,
          configuracion
        )
        .then(function(response) {
          //console.log(response.data);
          me.data = response.data[21];
          //console.log(me.data.seguimiento);
          me.separarSeguimientos();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    separarSeguimientos() {
      let data = this.data.seguimiento;
      this.splitData = data.split("~");
      this.splitData.forEach((element, index) => {
        this.dataSplit.push({
          seguimiento: element,
        });
      });
    },
    agregarComponente() {
      this.dataSplit.push({
        seguimiento: null,
      });
    },
    actualizar() {
      let a1;
      for (var i = 0; i < this.dataSplit.length; i++) {
        a1 = a1 + this.dataSplit[i].seguimiento;
      }
      console.log(a1);
    },
  },
};
</script>
